import { DEFAULT_ICON_AVATAR } from "../../containers/autorizacion/utils/AutorizacionConstant";
import { DATE_FORMATS } from "../../utils/Constant";
import moment from "moment";

const exportedObject = {
  formCierreCuentasData: {
    numeroIngreso: "",
    secuencialIngreso: null,
    fechaSalida: null,
    motivoEgreso: "",
    frecuenciaCobertura: "1",
    montoReclamado: "",
    codigoCobertura: "",
    causaInternamiento: "",
    tipoPss: "",
    nombrePss: "",
    codigoPss: null,
    categoriaPss: null,
    numeroReclamacion: null,
    numeroPrecertificacion: null,
    tienePrecertificacion: false,
    descripcionEstatus: null,
    numeroAfiliado: "",
    cedula: "",
    nss: "",
    nombreAfiliado: "",
    edad: "",
    fechaServicio: moment(new Date()).format(DATE_FORMATS.middledash_ymd),
    tipoServicio: "",
    plan: "",
    codigoPlan: null,
    anio: null,
    compania: null,
    ramo: null,
    secuenciaPoliza: null,
    codigoAsegurado: null,
    numeroPlastico: null,
    secuenciaAsegurado: null,
    fechaNacimiento: null,
    sexo: null,
    estadoCivil: null,
    categoriaAfiliado: null,
    checkCirugia: null,
    foto: DEFAULT_ICON_AVATAR,
    showAlert: false,
    alertConfig: {},
    numeroIngresoBusqueda: "",
    anioBusqueda: "",
    showDetalleIngreso: false,
    showRequired: false,
    showModalProcedimientosPermitidos: false,
    showModalMedicosParticipantes: false,
    aplicaExcepcion: false,
    procedimientos: [],
    procedimientosPermitidos: [],
    tieneMedicos: false,
    medicosParticipantes: [],
    tipoServicioOrigen: null
  },
  formCierreCuentasLoading: false,

  formConsultaCierresCuentasData: {
    numeroReclamacion: "",
    numeroAfiliado: "",
    fechaInicio: "",
    fechaFin: "",
    fechaServicio: "",
    fechaSalida: "",
    dataCierres: null,
    showAlert: false,
    alertConfig: {},
  },

  formConsultaCierresCuentasLoading: false,

  consultarCierresCuentasLoading: false, 

  consultarIngresoLoading: false,

  consultarDetalleCierreCuentaLoading: false,

  getProcedimientosPermitidosCierreCuentasLoading: false,

  validarProcedimientoCierreCuentasLoading: false,

  eliminarProcedimientoCierreCuentasLoading: false,

  consultarReclamantesLoading: false,

  cerrarCuentaClinicaLoading: false,

  getVoucherCierreCuentaLoading: false,
};

export default exportedObject;
